/**
 * 네비게이션 데이터 관련 유틸리티 함수
 */

/**
 * 권한 레벨 체크 유틸리티
 */
export const checkAuthLevel = {
  /**
   * SBS 계정인지 확인 (레벨 9)
   */
  isSBS: (level) => Number(level) === 9,
  
  /**
   * 마스터 계정인지 확인 (레벨 10)
   */
  isMaster: (level) => Number(level) === 10,
  
  /**
   * SBS가 아닌지 확인
   */
  isNotSBS: (level) => Number(level) !== 9,
};

/**
 * 조건부 메뉴 아이템 생성 헬퍼
 */
export const createConditionalMenuItems = (condition, items) => {
  return condition ? items : [];
};
